import React, {useState, useRef} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import { Tooltip } from "react-tooltip";
import StringUtil from "utils/StringUtil";
import DateUtil from "utils/DateUtil";
import CommonUtil from 'utils/CommonUtil';
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIUtils from "utils/UIUtils";
import UIInputMask from "../../../../components/input/UIInputMask";
import userRestRepository from "../../../../common/user/repository/UserRestRepository";

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();

    // receivedData
    const tskReqNo = receivedData?.tskReqNo;
    const tskReqModiSeq = receivedData?.tskReqModiSeq;   // 지급신청차수

    // **과제정보
    const [tskNm, setTskNm] = useState('');             // 과제명
    const [tskStDate, setTskStDate] = useState('');     // 과제시작기간
    const [tskEnDate, setTskEnDate] = useState('');     // 과제종료기간
    const [funPurUseCd, setFunPurUseCd] = useState(''); // 기금사용용도 코드
    const [funPurUseNm, setFunPurUseNm] = useState(''); // 기금사용용도명
    const [funPurUseNo,setFunPurUseNo] = useState('');  // 기금사용용도 넘버
    const [bizCd, setBizCd] = useState('');             // 사업분류코드
    const [bizNm, setBizNm] = useState('');             // 사업분류명
    const [bizKindCd1, setBizKindCd1] = useState('');   // 과제분야(대분류)
    const [bizKindNm1, setBizKindNm1] = useState('');   // 대분류명
    const [bizKindCd2, setBizKindCd2] = useState('');   // 과제분야(소분류)
    const [bizKindNm2, setBizKindNm2] = useState('');   // 소분류명
    const [perfCorp, setPerfCorp] = useState('');       // 수행기관
    const [reqAmt, setReqAmt] = useState(0);        // 신청 가능금액

    // ** 지원금 지급방식
    const [battSettYn, setBattSettYn] = useState('');    // 일괄정산
    const [forePayYn, setForePayYn] = useState('');     // 선지급
    const [tskTotAmt, setTskTotAmt] = useState(0);     // 총 지급신청금액

    // ** 지원금 지원 기업
    const [suppCorpCnt, setSuppCorpCnt] = useState(0);   // 지원기업 수
    const [suppCorpAmt, setSuppCorpAmt] = useState(0); // 중소기업 지원금액
    const [perfCorpCnt, setPerfCorpCnt] = useState(0); // 수행기관 수
    const [perfCorpAmt, setPerfCorpAmt] = useState(0); // 수행기관 지급금액

    // ** 기업정보
    const [corpNm,setCorpNm] = useState(''); //과제명
    const [bizNo,setBizNo] = useState(''); //사업자번호
    const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
    const [personNm,setPersonNm] = useState(''); //이름
    const [posiNm,setPosiNm] = useState(''); //직급
    const [deptNm,setDeptNm] = useState(''); //부서명
    const [emailAdres,setEmailAdres] = useState(''); //이메일
    const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호
    const [REC,setREC] = useState<any>([]);
    const [personId, setPersonId] = useState('');

    const [corpList, setCorpList] = React.useState<any[]>([]);
    const [corpListText, setCorpListText] = React.useState('');

    const [payReqDate, setPayReqDate] = useState('');   // 지급신청일
    let currentDate = DateUtil.toDateFormat(new Date, "YYYY-MM-DD");
    const [tskDate, setTskDate] = useState('');         // 과제기간

    const [bankNm, setBankNm] = useState('');       // 은행명
    const [bankCd, setBankCd] = useState('');       // 은행코드
    var bankNmTmp = "";
    var bankCdTmp = "";
    const [suppTotAmt, setSuppTotAmt] = useState(0);     // 중소기업 지원금액 합계
    const [perfTotAmt, setPerfTotAmt] = useState(0);     // 수행기관 지원금액 합계
    const [suppTotCnt, setSuppTotCnt] = useState(0);     // 중소기업 수
    const [perfTotCnt, setPerfTotCnt] = useState(0);     // 수행기관 수
    const [suppTmpAmt, setSuppTmpAmt] = useState(0);     // 중소기업 지원금액 합계(예비)
    const [perfTmpAmt, setPerfTmpAmt] = useState(0);     // 수행기관 지원금액 합계(예비)
    const [perfCnt, setPerfCnt] = useState(0);           // 수행기관 수(과제 신청 시 입력***)
    const [tskPeriod,setTskPeriod] = useState(''); //과제기간 월일 표기
    const [reqmainDonAmt, setReaminDonAmt] = useState(0);
    const [totalAmt, setTotalAmt] = useState(0);
    const [payReqNo, setPayReqNo] = useState('');
    const [elec, setElec] = useState('N');
    const [perfCorpYn, setPerfCorpYn] = useState('');

    const [helpList, setHelpList] = useState<any[]>([]);

    // 지원/수행기업 지원금액/갯수 임시 저장 변수
    const [suppTmpCnt, setSuppTmpCnt] = useState(0);
    const [perfTmpCnt, setPerfTmpCnt] = useState(0);

//                                                             지원기업            사업자등록번호     지원금액        대표자명           특수관계인여부              지급은행                지급계좌            예금주                수취인                                       유형코드         부가세포함여부
    const [suppCorpList, setSuppCorpList] = useState<any[]>([{ SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', SUPP_ACC_HOLDER : '', FIND_REF_NM: '', num : 0 , checked : false, SUPP_TP_CD: '', VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: '' }]);
    const [perfCorpList, setPerfCorpList] = useState<any[]>([{ SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', SUPP_ACC_HOLDER : '', FIND_REF_NM: '', num : 0 , checked : false, SUPP_TP_CD: '', VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: '' }]);
    const [nextNum,setNextNum] = useState(1); // suppCorpList 고유 key

    const [suppSave, setSuppSave] = useState(false);
    const [perfSave, setPerfSave] = useState(false);
    let elecYn = 'N';

    async function onClose(type) {
        if(type == '2120'){
            setSuppTmpCnt(suppTotCnt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 갯수 되돌리기
            setSuppTmpAmt(suppTotAmt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 총액 되돌리기
            setModal2120IsOpen(false);
            // @ts-ignore
            IBSheet.sheet.dispose();
        }else if(type == '2122'){
            setPerfTmpCnt(perfTotCnt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 갯수 되돌리기
            setPerfTmpAmt(perfTotAmt);      // 행 삭제하고 저장하지 않은채로 모달 닫았을 때 총액 되돌리기
            setModal2122IsOpen(false);
            // @ts-ignore
            IBSheet.sheet_modal.dispose();
        }
    }

    codeDataStore.read("[BANK]",).then(() => {
        var codeData = codeDataStore.get("[BANK]");
        codeData = codeData.filter((v) => { return (v.code !== '019' && v.code !== '084' && v.code !== '080' && v.code !== '010') });
        for(var i=0; i<codeData.length; i++) {
            bankNmTmp += "|" + codeData[i].name;
            bankCdTmp += "|" + codeData[i].code;
        }

        setBankNm(bankNmTmp);
        setBankCd(bankCdTmp);

    });

    async function onAfterOpen(type) {
        if(type == '2120'){                             // 지원기업 팝업 출력
            if(perfCorpYn != 'N') {
                sheetId.current = 'modal_2120_List';
                sheetCols.current = modal2122Cols_supp;  // 축소된 지원기업 헤더 출력
            } else {
                sheetId.current = 'modal_2120_List';
                sheetCols.current = modal2120Cols;      // 온전한 지원기업 헤더 출력
            }
            setSuppTmpCnt(suppTotCnt);
            ib.create();
        }else if(type == '2122') {                          // 수행기업 팝업 출력
            sheetId.current = 'modal_2122_List';
            sheetCols.current = modal2122Cols;
            setPerfTmpCnt(perfTotCnt);
            ib_modal.create();
        }


        return () => {
            // @ts-ignore
            IBSheet.disposeAll(true);
        }

    }

    function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

    function dateToStr(dateText) {

        if(dateText == null) return '';

        if(/^(-?)[0-9]+$/.test(dateText)){
            dateText = Number(dateText);
        }
        let date = new Date(dateText);
        let week = new Array('일', '월', '화', '수', '목', '금', '토');


        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let dayName = week[date.getDay()];

        return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
    }

    function dueDateConverter(stDate, enDate){
        if(stDate == null || enDate == null) return '';

        if(/^(-?)[0-9]+$/.test(stDate)) stDate = Number(stDate);
        if(/^(-?)[0-9]+$/.test(enDate)) enDate = Number(enDate);

        const st = new Date(stDate);
        const en = new Date(enDate);
        const timeGap = st.getTime() - en.getTime();

        // 남은 일수 카운트
        const remainDay = Math.ceil(timeGap / (1000 * 60 * 60 * 24));

        return '('+remainDay+'일)';
    }

    const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var id = event.target.id;
        if(id === 'rd-1-1') {
            setForePayYn('N');
        } else if(id === 'rd-1-2'){
            setForePayYn('Y');
        }
    };

    async function initCall(){

        let param = {
                TSK_REQ_NO: tskReqNo,
                TSK_REQ_MODI_SEQ: tskReqModiSeq,
                // PERSON_ID: "75WO57Y6663377A620",
            }

            // console.log(param);

        const response:any = await CommonUtil.execute({
            url:"usr_2119",
            data: param,
            progressBar:true
        })
        .then((response: any) => {
//             console.log(response);

            setTskNm(response.TSK_NM);
            setTskStDate(dateToStr(response.TSK_ST_DATE));
            setTskEnDate(dateToStr(response.TSK_EN_DATE));
            setBizCd(response.BIZ_CD);
            setBizNm(response.BIZ_NM);
            setFunPurUseCd(response.FUN_PUR_USE_CD);
            setFunPurUseNo(response.FUN_PUR_USE_NO);
            setFunPurUseNm(response.FUN_PUR_USE_NM);
            setBizKindCd1(response.BIZ_KIND_CD_1);
            setBizKindCd2(response.BIZ_KIND_CD_2);
            setBizKindNm1(response.BIZ_KIND_NM_1);
            setBizKindNm2(response.BIZ_KIND_NM_2);
            setPerfCorp(response.PERF_CORP);
            setBattSettYn(response.BATT_SETT_YN);
            setForePayYn(response.FORE_PAY_YN);
            // setTskTotAmt(Number(response.TSK_TOT_AMT));
            setSuppCorpCnt(response.SUPP_CORP_CNT);
            setSuppTmpCnt(response.SUPP_CORP_CNT);
            setPerfTmpCnt(response.PERF_CORP_CNT);
            setSuppCorpAmt(Number(response.SUPP_CORP_AMT));
            setPerfCorpCnt(response.PERF_CORP_CNT);
            setPerfCorpAmt(Number(response.PERF_CORP_AMT));
            setCorpNm(response.CORP_NM);
            setBizNo(response.BIZ_NO);
            // setPayReqUserNm(response.PAY_REQ_USERNM);
            setPersonNm(response.PAY_REQ_USERNM);
            setPosiNm(response.POSI_NM);
            setDeptNm(response.DEPT_NM);
            setEmailAdres(response.EMAIL_ID);
            // setEmailId(response.EMAIL_ID);
            setOfcTelNo(response.OFC_TEL_NO);
            setPerfCorpYn(response.PERF_CORP_YN);
            setCorpRegNo(response.CORP_REG_NO);
            setPersonId(response.PAY_REQ_USERID);
            if(response.REQ_AMT > 0) {
                setReqAmt(Number(response.REQ_AMT));
            }

           setTskDate(dateToStr(response.TSK_ST_DATE) + " ~ " + dateToStr(response.TSK_EN_DATE));

            const result = response;
            if(result.REC.length != 0){
                setREC(result.REC);
                let info = result.REC[0];
                // setCorpNm(info.CORP_NM);
                // setBizNo(info.BIZ_NO);
                // setCorpRegNo(info.CORP_REG_NO);
                // setPersonNm(info.PERSON_NM);
                // setPersonId(info.PERSON_ID);
                // setPosiNm(info.POSI_NM);
                // setDeptNm(info.DEPT_NM);
                // setEmailAdres(info.EMAIL_ADRES);
                // setOfcTelNo(info.OFC_TEL_NO);
            }

            setCorpList(result.REC2);

            setCorpListText(
                result.REC2.map(function(value){
                    return value.CORP_NM
                }).join(',')
            )

        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });


    }

//  20244.09.02 개선내용 추가  
//   지급신청서에 대한 서면/전자인증을 진행하시겠습니까?
// - 안내1. 서면인증:직인본 스캔하여 파일 업로드(첨부파일기능 활용)
// - 안내2. 성과공유제 사업은 별도 지급신청양식 반드시 첨부 필요
    const elecConfirm = async () => {
        const value = await UIUtils.elecConfirm(
            <p className="msg">
                지급신청서에 대한 전자인증를 진행하시겠습니까?<br/>
                - 안내1. 서면인증:직인본 스캔하여 파일 업로드(첨부파일기능 활용)<br/>
                - 안내2. 성과공유제 사업은 별도 지급신청양식 반드시 첨부 필요
            </p>
        );

        saveConfirm(value);

        console.log("confirmModal", value);
    }


    // 지금 신청 등록
    async function SavePay() {

        if(perfCorpYn === 'Y' && Number(totalAmt) >= 0 && Number(perfTotAmt) <= 0){
            UIUtils.alert('수행기업 지급 정보를 입력해주세요').then();
            return;
        }

        if(Number(totalAmt) <= 0 || Number(suppTotAmt) <= 0){
            UIUtils.alert('지원기업 지급 정보를 입력해주세요').then();
            return;
        }

        if(Number(perfTotAmt) > 0 ) {
            if (suppTotAmt !== perfTotAmt) {
                UIUtils.alert('지원금액합계와 지급금액합계금액을 동일하게 입력해 주세요.').then();
                return;
            }
        }
        
        if(personNm == ''){
            await UIUtils.alert("담당자명을 입력해주세요.");
            return;
        }


        if(Number(reqAmt) < Number(suppTotAmt)) {

            await UIUtils.alert("잔여 지급신청 금액이 부족합니다. 신청 가능 금액 : " + StringUtil.formatNumber(Number(reqAmt)) + "원 입니다.").then();
            return;
        }


        if(await UIUtils.confirm('저장하시겠습니까?')){


            await elecConfirm();

        }


    }

    async function saveConfirm(checked){

        let payReqNoTmp = await getPayReqNo();

        var param = {
            PAY_REQ_NO: payReqNoTmp,           // 지급신청번호
            // PAY_REQ_NO: payReqNo,           // 지급신청번호
            TSK_NM: tskNm,                  // 과제명
            TSK_REQ_NO: tskReqNo,           // 과제번호
            TSK_ST_DATE: tskStDate,         // 과제시작일
            TSK_EN_DATE: tskEnDate,         // 과제종료일
            BIZ_CD: bizCd,                  // 사업분류
            FUN_PUR_USE_CD: funPurUseCd,    //
            FUN_PUR_USE_NO: funPurUseNo,    //
            TSK_REQ_MODI_SEQ: tskReqModiSeq,// 과제신청 차수
            BIZ_KIND_CD_1: bizKindCd1,      // 과제분야 대문류
            BIZ_KIND_CD_2: bizKindCd2,      // 과제분야 소분류
            FORE_PAY_YN: forePayYn,         // 선지급 여부
            TOT_AMT: suppTotAmt,             // 총 지급신청금액
            PAY_AMT: suppTotAmt,
            SUPP_CORP_AMT: suppCorpAmt,     // 지원기업 지원금액
            CORP_NM: corpNm,                // 기업명
            BIZ_NO: bizNo,                  // 사업자번호
            PAY_REQ_USER_ID: personId,
            PERSON_NM : personNm,
            POSI_NM: posiNm,                // 직급
            DEPT_NM: deptNm,                // 부서
            EMAIL_ADRES: emailAdres,           // 이메일
            OFC_TEL_NO: ofcTelNo,           // 전화번호
            SUPP_LIST: suppCorpList,        // 지원기업 리스트
            PERF_LIST: perfCorpList,        // 수행기업 리스트
            SUPP_CORP_CNT: suppCorpCnt,     // 지원기업 수
            PERF_CORP: perfCorpYn,            // 수행기관
            ELEC_APPR_YN: elecYn,
            ELEC_APPR_DT: "",
        }

        if(checked){
            //전자인증수정
            const result = await userRestRepository.certify("전자서명값");
            if(result.result){
                param.ELEC_APPR_YN = 'Y';
                param.ELEC_APPR_DT = currentDate;//전자인증일자
                savePay(param);
            }
        }else{
            savePay(param);
        }

        console.log(param);

    }

    async function savePay(param:any){

        // 지급 저장 진행
        const response:any = await CommonUtil.execute({
            url: "usr_2119_c001",
            data: param,
            progressBar:true
        }).then(() => {
            UIUtils.alert('저장되었습니다.')
                .then(() => {
                    history.push({pathname: './usr_2123'});
                });
        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });

    }

    async function getPayReqNo() {
        const response:any = await CommonUtil.execute({
            url:"newPayReqNo",
        })

        setPayReqNo(response.LST_GIV_NO);

        if(response.LST_GIV_NO != undefined || response.LST_GIV_NO != ''){
            return response.LST_GIV_NO;
        } else {
            UIUtils.alert('일시적인 오류가 발생했습니다. \n 관리자에게 문의하세요').then();
            return
        }

    }

    const manageSelect = (e) => {
        let selectManage = REC.filter(a => a.PERSON_ID == e.target.value);

        if(selectManage.length != 0){
            let info = selectManage[0];
            setPersonId(info.PERSON_ID)
            setCorpNm(info.CORP_NM);
            setBizNo(info.BIZ_NO);
            setCorpRegNo(info.CORP_REG_NO);
            setPersonNm(info.PERSON_NM);
            setPosiNm(info.POSI_NM);
            setDeptNm(info.DEPT_NM);
            setEmailAdres(info.EMAIL_ADRES);
            setOfcTelNo(info.OFC_TEL_NO);
        }

    };


    React.useEffect(() => {
        // getPayReqNo();
    },[]);

	React.useEffect(() => {
        setPayReqDate(dateToStr(currentDate));
        initCall();

    },[]);


    ///////////////// 그리드 /////////////////

    // 수행기업 목록(PopUp)
    let modal2122Cols = [
        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
        {"Header": ["수행기관 지급 계좌 정보","수행기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","특수관계인\n여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["수행기관 지급 계좌 정보","지급은행"],"Type": "Enum","Name": "SUPP_ACC_BANK_CD","RelWidth": 1.5,"Align": "Center","CanEdit": 1,"Enum": bankNm,"EnumKeys": bankCd},
        {"Header": ["수행기관 지급 계좌 정보","지급계좌"],"Type": "Text","Name": "SUPP_ACC_NO","RelWidth":1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","예금주"],"Type": "Text","Name": "SUPP_ACC_HOLDER","RelWidth": 1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["수행기관 지급 계좌 정보","부가세 포함 여부"],"Type": "Enum","Name": "VAT_YN","RelWidth": 1.5,"Align": "Center","CanEdit": 1, "Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["조회결과","수취인"],"Type": "Text","Name": "FIND_REF_NM","RelWidth": 1.5,"Align": "Center","CanEdit": 0},
        {"Header": ["조회결과","ERR_CD"],"Type": "Text","Name": "ERR_CD","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
        {"Header": ["조회결과","ERR_MSG"],"Type": "Text","Name": "ERR_MSG","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
    ];

    let modal2122Cols_supp = [
        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
        {"Header": ["기금지원내역","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
        {"Header": ["기금지원내역","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
        {"Header": ["기금지원내역","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
        {"Header": ["기금지원내역","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["기금지원내역","협력사\n여부"],"Type": "Enum","Name": "PARTNER_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["기금지원내역","중소기업\n여부"],"Type": "Enum","Name": "SUPP_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["기금지원내역","특수관계인\n여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
    ];

    // 지원기업 목록(수행기업 없는 경우)
    let modal2120Cols = [
        {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 0.7,"CanEdit": "1", "BoolIcon": 4},
        {"Header": ["중소기업 지급 계좌 정보","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 1.5,"Align": "Right","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","협력사\n여부"],"Type": "Enum","Name": "PARTNER_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["중소기업 지급 계좌 정보","중소기업\n여부"],"Type": "Enum","Name": "SUPP_CORP_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["중소기업 지급 계좌 정보","특수관계인\n여부"],"Type": "Enum","Name": "SPC_RELATE_PERSON_YN","Align": "Center","CanEdit": 1,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
        {"Header": ["중소기업 지급 계좌 정보","지급은행"],"Type": "Enum","Name": "SUPP_ACC_BANK_CD","RelWidth": 1.5,"Align": "Center","CanEdit": 1,"Enum": bankNm,"EnumKeys": bankCd },
        {"Header": ["중소기업 지급 계좌 정보","지급계좌"],"Type": "Text","Name": "SUPP_ACC_NO","RelWidth":1.5,"Align": "Center","CanEdit": 1},
        {"Header": ["중소기업 지급 계좌 정보","예금주"],"Type": "Text","Name": "SUPP_ACC_HOLDER","RelWidth": 1,"Align": "Center","CanEdit": 1},
        {"Header": ["조회결과","수취인"],"Type": "Text","Name": "FIND_REF_NM","RelWidth": 1,"Align": "Center","CanEdit": 0},
        {"Header": ["조회결과","ERR_CD"],"Type": "Text","Name": "ERR_CD","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
        {"Header": ["조회결과","ERR_MSG"],"Type": "Text","Name": "ERR_MSG","RelWidth": 1,"Align": "Center","CanEdit": 0, "Visible": 0},
    ];

    const [modal2120IsOpen, setModal2120IsOpen] = useState(false);
    const [modal2122IsOpen, setModal2122IsOpen] = useState(false);

    let sheetId = useRef<string>("");
    let sheetCols = useRef<any>([]);
    let sheetCols_2120 = useRef<any>([]);
    let sheetCols_2122 = useRef<any>([]);

    const [totalRowCnt,setTotalRowCnt] = useState(0);
    const [showRowCnt,setShowRowCnt] = useState(100); //기본 row count

    //초기 데이터 설정
    let totalCnt:number = 0;
    let totalCntRight:number = 0;
    let defaultRowCnt = 100;
    let SheetData = {};
    let SheetData_supp = {};
    let SheetData_perf = {};
    const rowCnt = useRef<string>("100");
    const rowCnt_modal = useRef<string>("100");

    let data_modal = {};
    let totalCnt_dev_modal;


    //====== 그리드 공통 부 START
    var ib = ib||{};
    ib = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": 999,
                "AutoRowHeight": 1,
                "InfoRowConfig": "0",
                "Alternate":"0",
                "HeaderMerge": 6,
                "HeaderCheck": 1,
                "HeaderCheckMode": 0,         // 체크박스 all 선택 시 모든 화면의 데이터를 체크
                "CanSort": 0,                 // 소팅옵션 off
                "ShowFilter": 1,             // 필터행 표시
                "dataMerge":1,
                // "Height": "auto",
                "ZIndex": 900,
                "MenuMaxHeight": 300        // Enum 콤보박스 사이즈 조절
            },
            "Cols": [
                {"Header": ["선택", {"Value": "", "Align": "Center","Icon": "Check","HeaderCheck": 1, "IconAlign": "Center"} ],"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 1,"CanEdit": "1", "BoolIcon": 4},
                {"Header": ["중소기업 지급 정보","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 1},
                {"Header": ["중소기업 지급 정보","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 1},
                {"Header": ["중소기업 지급 정보","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
            ],
        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //헤더행과 필터행 강제 머지

                //지원기업 헤더행 머지
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "sCheckBox", sheet.getRowById("Filter"), "sCheckBox");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CEO_NM", sheet.getRowById("Filter"), "SUPP_CEO_NM");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SPC_RELATE_PERSON_YN", sheet.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_BANK_CD", sheet.getRowById("Filter"), "SUPP_ACC_BANK_CD");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_NO", sheet.getRowById("Filter"), "SUPP_ACC_NO");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet.getRowById("Filter"), "SUPP_ACC_HOLDER");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "FIND_REF_NM", sheet.getRowById("Filter"), "FIND_REF_NM");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CORP_YN", sheet.getRowById("Filter"), "SUPP_CORP_YN");
                //@ts-ignore
                sheet.setMergeRange( sheet.getRowById("HR1"), "PARTNER_CORP_YN", sheet.getRowById("Filter"), "PARTNER_CORP_YN");

                //초기 데이터 로딩
                initSheet_modal_2120();
            },
            //시트 클릭시 이벤트 처리
            onAfterClick:function(evtParam){
                if(evtParam.col === 'FIND_REF_NM' ){
                    if ( evtParam.row.ERR_CD !== '0000'){
                        UIUtils.alert('['+ evtParam.row.ERR_CD + ']' + evtParam.row.ERR_MSG).then();
                        return;
                    }
                }
            },
            //시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
            onRenderFinish  :function(evtParam){
            },
            onBeforeDataLoad:function (evtParam) {
            },
            onAfterGotoPage:function (evtParam) {
            },
            onAfterChange : function(evtParam) {

                //@ts-ignore
                var rows = sheet.getDataRows();
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += rows[i]["PAY_AMT"];
                }
                setSuppTmpAmt(sum);
                
  				evtParam.sheet.setValue({row:evtParam.row, col:"FIND_REF_NM", val:"", render:1});
            },
            onImportFinish:function(evtParam){          // 엑셀 임포트 이벤트
                let rows = evtParam.data;
                rows.forEach((v) => { v["PAY_AMT"] = Math.floor(Number(v["PAY_AMT"]))+'' });
                rowCnt.current = evtParam.data.length;
                setSuppTmpCnt(evtParam.data.length);

                //@ts-ignore
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += Number(rows[i]["PAY_AMT"]);
                }
                setSuppTmpAmt(sum);
                //@ts-ignore
                sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;
            options.Cols = sheetCols.current;
            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet', // 생성할 시트의 id
                el: sheetId.current, // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                data: SheetData_supp // 생성될 시트의 정적데이터
            });

            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //엑셀 다운로드
        'exportData':function () {
        },
    }



    var ib_modal = ib_modal||{};
    ib_modal = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": 999,
                "AutoRowHeight": 1,
                "InfoRowConfig": "0",
                "Alternate":"0",
                "HeaderMerge": 6,
                "HeaderCheck": 1,
                "HeaderCheckMode": 0,
                "CanSort": 0,                // 소팅옵션 off
                "ZIndex": 900,               // 팝업에서 enum 출력
                "ShowFilter": 1,             // 필터행 표시
                "dataMerge":1,
                // "Height": "auto",
                "MenuMaxHeight": 300        // Enum 콤보박스 사이즈 조절
            },
            //틀고정 좌측 컬럼 설정
            "Cols": []

        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //헤더행과 필터행 강제 머지
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "sCheckBox", sheet_modal.getRowById("Filter"), "sCheckBox");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "PAY_AMT", sheet_modal.getRowById("Filter"), "PAY_AMT");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_CEO_NM", sheet_modal.getRowById("Filter"), "SUPP_CEO_NM");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SPC_RELATE_PERSON_YN", sheet_modal.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_ACC_BANK_CD", sheet_modal.getRowById("Filter"), "SUPP_ACC_BANK_CD");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_ACC_NO", sheet_modal.getRowById("Filter"), "SUPP_ACC_NO");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet_modal.getRowById("Filter"), "SUPP_ACC_HOLDER");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "VAT_YN", sheet_modal.getRowById("Filter"), "VAT_YN");
                //@ts-ignore
                sheet_modal.setMergeRange( sheet_modal.getRowById("HR1"), "FIND_REF_NM", sheet_modal.getRowById("Filter"), "FIND_REF_NM");


                //초기 데이터 로딩
                initSheet_modal_2122();
            },
            //시트 더블클릭시 이벤트 처리
            onAfterClick:function(evtParam){
                if(evtParam.col === 'FIND_REF_NM' ){
                    if ( evtParam.row.ERR_CD !== '0000'){
                        UIUtils.alert('['+ evtParam.row.ERR_CD + ']' + evtParam.row.ERR_MSG).then();
                        return;
                    }
                }
            },
            //시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
            onRenderFinish  :function(evtParam){
            },
            onBeforeDataLoad:function (evtParam) {
            },
            onAfterGotoPage:function (evtParam) {
            },
            onAfterChange : function(evtParam) {
                //@ts-ignore
                var rows = sheet_modal.getDataRows();
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += rows[i]["PAY_AMT"];
                }
                setPerfTmpAmt(sum);
            },
            onImportFinish:function(evtParam){          // 엑셀 임포트 이벤트
                let rows = evtParam.data;
                rows.forEach((v) => { v["PAY_AMT"] = Math.floor(Number(v["PAY_AMT"]))+'' });
                rowCnt_modal.current = evtParam.data.length;
                setPerfTmpCnt(evtParam.data.length);

                //@ts-ignore
                var sum = 0;
                for(var i=0; i<rows.length; i++){
                    sum += Number(rows[i]["PAY_AMT"]);
                }
                setPerfTmpAmt(sum);
                //@ts-ignore
                sheet_modal.rerender(1); //최종 수정된 내용을 화면에 반영한다.
            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;
            options.Cols = sheetCols.current;

            //sheetId
            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet_modal', // 생성할 시트의 id
                el: sheetId.current, // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                data: SheetData // 생성될 시트의 정적데이터
            });

            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //엑셀 다운로드
        'exportData':function () {

        },
        //조회 데이터
        'data':[]
    }

    //====== 그리드 공통 부  END

    //====== 그리드 데이터 가지고 오기  START

    async function initSheet_modal_2120() {

        // @ts-ignore
        sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

         if(suppSave == true){
            // @ts-ignore
             sheet.loadSearchData(suppCorpList);
         } else {
            // @ts-ignore
             sheet.loadSearchData(SheetData);
         }

    };

    async function initSheet_modal_2122() {

        // @ts-ignore
        sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

        if(perfSave == true){
            // @ts-ignore
            sheet_modal.loadSearchData(perfCorpList);
        }else {
            // @ts-ignore
            sheet_modal.loadSearchData(SheetData_perf);
        }

    };

    //====== 그리드 데이터 가지고 오기  END

    //행 추가
    async function addRow (type){

        if( type == '2120'){
            //@ts-ignore
            sheet.addRow({ visible: 1 });

            //전체 row visible 1 처리
            //@ts-ignore
            sheet.getDataRows().map(e => {
                e.Visible = 1;
                return e;
            })

            const suppNextList = suppCorpList.concat({
                SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', FIND_REF_NM: '', num : 0 , checked : false, VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: ''
            });

            setSuppCorpList(suppNextList);
            //@ts-ignore
            setSuppTmpCnt(sheet.getDataRows().length);

            //@ts-ignore
            sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.

        } else if( type == '2122') {
            //@ts-ignore
            sheet_modal.addRow({ visible: 1 });

            //전체 row visible 1 처리
            //@ts-ignore
            sheet_modal.getDataRows().map(e => {
                e.Visible = 1;
                return e;
            })

            const perfNextList = perfCorpList.concat({
                SUPP_CORP_NM : '', SUPP_BIZ_NO : '', PAY_AMT : '', SUPP_CEO_NM : '', SPC_RELATE_PERSON_YN : '', SUPP_ACC_BANK_CD : '', SUPP_ACC_NO : '', FIND_REF_NM: '', num : 0 , checked : false, VAT_YN: '', SUPP_CORP_YN: '', PARTNER_CORP_YN: '', ERR_CD: '', ERR_MSG: ''
            });

            setPerfCorpList(perfNextList);
            //@ts-ignore
            setPerfTmpCnt(sheet_modal.getDataRows().length);

            //@ts-ignore
            sheet_modal.rerender(1); //최종 수정된 내용을 화면에 반영한다.
        }


    }

    // 행 삭제
    async function delRow (type) {

        let corpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};
        let sum = 0;

        if(type == '2120'){

            //@ts-ignore
            var fRows = sheet.getDataRows().filter(x => x.sCheckBox === 1);

            //@ts-ignore
            sheet.removeRows(fRows);

            //@ts-ignore
            var rows = sheet.getDataRows();
            for(var i=0; i<rows.length; i++){
                // @ts-ignore
                corpItem = {
                    SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                    SUPP_BIZ_NO: rows[i]["SUPP_BIZ_NO"],
                    PAY_AMT: rows[i]["PAY_AMT"],
                    SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                    SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                    SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                    SUPP_ACC_NO: rows[i]["SUPP_ACC_NO"],
                    SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                    VAT_YN: rows[i]["VAT_YN"],
                    SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                    PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                    ERR_CD: rows[i]["ERR_CD"],
                    ERR_MSG: rows[i]["ERR_MSG"],
                    FIND_REF_NM: rows[i]["FIND_REF_NM"],
                }
                corpItems.push(corpItem);
                sum += rows[i]["PAY_AMT"];
            }
            setSuppTmpAmt(sum);
            setSuppTmpCnt(rows.length);

            // @ts-ignore
            sheet.loadSearchData(corpItems);

            //@ts-ignore
            sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.


        } else if(type == '2122'){

            //@ts-ignore
            var fRows = sheet_modal.getDataRows().filter(x => x.sCheckBox === 1);

            //@ts-ignore
            sheet_modal.removeRows(fRows);

            //@ts-ignore
            var rows = sheet_modal.getDataRows();
            for(var i=0; i<rows.length; i++){
                // @ts-ignore
                corpItem = {
                    SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                    SUPP_BIZ_NO: rows[i]["SUPP_BIZ_NO"],
                    PAY_AMT: rows[i]["PAY_AMT"],
                    SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                    SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                    SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                    SUPP_ACC_NO: rows[i]["SUPP_ACC_NO"],
                    SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                    VAT_YN: rows[i]["VAT_YN"],
                    SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                    PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                    ERR_CD: rows[i]["ERR_CD"],
                    ERR_MSG: rows[i]["ERR_MSG"],
                    FIND_REF_NM: rows[i]["FIND_REF_NM"],
                }
                corpItems.push(corpItem);
                sum += rows[i]["PAY_AMT"];
            }
            setPerfTmpAmt(sum);
            setPerfTmpCnt(rows.length);

            // @ts-ignore
            sheet_modal.loadSearchData(corpItems);

            //@ts-ignore
            sheet_modal.rerender(1); //최종 수정된 내용을 화면에 반영한다.

        }

    }

    // 취소버튼
    async function clickCancel() {

        history.push({
            pathname: './usr_2114',
        });
    }

    // 지원/수행 기업 저장
    async function saveCorp(type) {

        let rows;

        if(type == '2120'){
            // @ts-ignore
            rows = sheet.getDataRows();
        } else if(type == '2122'){
            // @ts-ignore
            rows = sheet_modal.getDataRows();
        }

        // 행 입력 안하고 저장 시 return
        if(rows.length <= 0 ){
            UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
            return;
        }

        let arrBizNos: string[] = [];
        let bizNoDplctMsg = "";
        let chkMsg = "";

        // 필수값 체크   *** 예금주조회로 이동 해야함***
        if(type == '2122') {
            for(var i=0; i<rows.length; i++) {
                arrBizNos.push(StringUtil.replaceAll(rows[i]["SUPP_BIZ_NO"], "-", ""));
                if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                    rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_ACC_BANK_CD"] == "" ||
                    rows[i]["SUPP_ACC_NO"] == "" || rows[i]["SUPP_ACC_HOLDER"] == "" || rows[i]["VAT_YN"] == ""
                ){
                    UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                    return;

                }/*else if(rows[i]["SPC_RELATE_PERSON_YN"] == 'Y'){
                    UIUtils.alert('특수관계인 여부가 아니오 일때만 저장 가능합니다.').then();
                    return;
                }*/ else if(rows[i]["FIND_REF_NM"] == undefined || rows[i]["FIND_REF_NM"] == "") {
                    UIUtils.alert('예금주 조회 후 저장버튼을 선택해주세요.').then();
                    return;
                } else if(rows[i]["FIND_REF_NM"] === "오류") {
                    UIUtils.alert('예금주조회에서 실패한 계좌정보는 삭제 후 다시 시도해 주세요.').then();
                    return;
                }
            }
        } else {
            for(var i=0; i<rows.length; i++) {
				let typeNm = "";
                arrBizNos.push(StringUtil.replaceAll(rows[i]["SUPP_BIZ_NO"], "-", ""));
                
                if (rows[i]["SUPP_CORP_NM"] == "") {
					typeNm = "SUPP_CORP_NM";
                }else if(rows[i]["SUPP_BIZ_NO"] == ""){
					typeNm = "SUPP_BIZ_NO";
				}else if(rows[i]["PAY_AMT"] == ""){
					typeNm = "PAY_AMT";
				}else if(rows[i]["SUPP_CEO_NM"] == ""){
					typeNm = "SUPP_CEO_NM";
				}else if(rows[i]["SPC_RELATE_PERSON_YN"] == ""){
					typeNm = "SPC_RELATE_PERSON_YN";
				}else if(rows[i]["SUPP_ACC_BANK_CD"] == ""){
					typeNm = "SUPP_ACC_BANK_CD";
				}else if(rows[i]["SUPP_ACC_NO"] == ""){
					typeNm = "SUPP_ACC_NO";
				}else if(rows[i]["SUPP_ACC_HOLDER"] == ""){
					typeNm = "SUPP_ACC_HOLDER";
				}else if(rows[i]["SUPP_CORP_YN"] == ""){
					typeNm = "SUPP_CORP_YN";
				}else if(rows[i]["PARTNER_CORP_YN"] == ""){
					typeNm = "PARTNER_CORP_YN";
				}
				else if(rows[i]["SPC_RELATE_PERSON_YN"] == 'Y'){
                    UIUtils.alert('특수관계인 여부가 아니오 일때만 저장 가능합니다.').then();
                    return;
                }else if(perfCorpYn == 'N' && (rows[i]["FIND_REF_NM"] == undefined || rows[i]["FIND_REF_NM"] == "")) {
                    UIUtils.alert('예금주 조회 후 저장버튼을 선택해주세요.').then();
                    return;
                }else if(perfCorpYn == 'N' && rows[i]["FIND_REF_NM"] === "오류") {
                    UIUtils.alert('예금주조회에서 실패한 계좌정보는 삭제 후 다시 시도해 주세요.').then();
                    return;
                }else if(perfCorpYn == 'N' && rows[i]["SUPP_CORP_YN"] == 'N') {
                    UIUtils.alert('중소기업여부가 예 일때만 저장 가능합니다..').then();
                    return;
                }
                
                if(typeNm != ""){
					setTimeout(function(){
						// @ts-ignore
						sheet.focus(rows[i],typeNm);
					},10);
					
                    UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                    return;
				}
            }
        }


        const rstbizNos: any = arrBizNos.reduce((accu, curr) => {
          accu.set(curr, (accu.get(curr) || 0) + 1);
          return accu;
        }, new Map());

        for (let [key, value] of rstbizNos.entries()) {
          if (value > 1) {
            bizNoDplctMsg += "사업자등록번호: " + key;
            bizNoDplctMsg += " (" + value + "건)\n";
          }
          
		  // corpList에 존재하는지 확인
		  	
		  if (!corpList.some(corp => corp.BIZ_NO === key) && corpList.length > 0) {
			chkMsg += key+" ";
		  }
        }
		
		
       if (chkMsg !== "" && type == '2122') {
            UIUtils.alert("과제신청시 등록된 수행기관 사업자번호가 아닙니다 사업자번호:"+ chkMsg).then();
          return;
        }
        //if (bizNoDplctMsg !== "") {
       //     UIUtils.alert('중복되는 사업자등록번호가 존재합니다.').then();
        //  return;
       // }


        let suppCorpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        let perfCorpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};

        var sum = 0;

        for(var i=0; i<rows.length; i++) {
            corpItem = {
                SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: rows[i]["SUPP_BIZ_NO"],
                PAY_AMT: rows[i]["PAY_AMT"],
                SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: rows[i]["SUPP_ACC_NO"],
                SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                FIND_REF_NM: rows[i]["FIND_REF_NM"],
                VAT_YN: rows[i]["VAT_YN"],
                SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                ERR_CD: rows[i]["ERR_CD"],
                ERR_MSG: rows[i]["ERR_MSG"],
            }
            if(type == '2120') {
                suppCorpItems.push(corpItem);
            } else if(type == '2122'){
                perfCorpItems.push(corpItem);
            }
            sum += rows[i]["PAY_AMT"];
        }

        if(Number(reqAmt) < Number(sum)) {
            await UIUtils.alert("잔여 지급신청 금액이 부족합니다. 신청 가능 금액 : \n" + StringUtil.formatNumber(Number(reqAmt)) + "원 입니다.").then();
            return;
        }

        debugger;

        if(type == '2120') {
            setSuppSave(true);
            setSuppCorpList(suppCorpItems);
            setSuppTotCnt(rows.length);
            setSuppTmpCnt(rows.length);
            setSuppTmpAmt(sum);
            setSuppTotAmt(sum);
            setTotalAmt(sum);
            setModal2120IsOpen(false);
            // @ts-ignore
            IBSheet.sheet.dispose();
            // onClose('2120');
        } else if(type == '2122'){
            setPerfSave(true);
            setPerfCorpList(perfCorpItems);
            setPerfTotCnt(rows.length);
            setPerfTmpCnt(rows.length);
            setPerfTmpAmt(sum);
            setPerfTotAmt(sum);
            setModal2122IsOpen(false);
            // @ts-ignore
            IBSheet.sheet_modal.dispose();
            // onClose('2122');
        }
        UIUtils.alert('저장되었습니다.').then();

    }



    // 예금주 조회
    async function checkInq(type) {

        let rows:any;
        let tempRows:any;

        if(type == '2122') {
            // @ts-ignore
            rows = sheet_modal.getDataRows().filter(x => x.sCheckBox === 1);
            // @ts-ignore
            tempRows = sheet_modal.getDataRows().filter(x => x.sCheckBox !== 1);
            
            if (rows.length === 0) {
	            // @ts-ignore
	            rows = sheet_modal.getDataRows().filter(x => x.FIND_REF_NM === "오류" || x.FIND_REF_NM === undefined || x.FIND_REF_NM === "");
	            // @ts-ignore
	            tempRows =  sheet_modal.getDataRows().filter(x => x.FIND_REF_NM !== "오류" && x.FIND_REF_NM !== undefined && x.FIND_REF_NM !== "");
		    }
            
            for(var i=0; i<rows.length; i++) {
                if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                    rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_ACC_BANK_CD"] == "" ||
                    rows[i]["SUPP_ACC_NO"] == "" || rows[i]["SUPP_ACC_HOLDER"] == "" || rows[i]["VAT_YN"] == ""
                ){
                    UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                    return;
                }
            }
        } else if(type == '2120'){
            // @ts-ignore
            rows = sheet.getDataRows().filter(x => x.sCheckBox === 1);
            // @ts-ignore
            tempRows = sheet.getDataRows().filter(x => x.sCheckBox !== 1);
            
	        if (rows.length === 0) {
	            // @ts-ignore
	            rows = sheet.getDataRows().filter(x => x.FIND_REF_NM === "오류" || x.FIND_REF_NM === undefined || x.FIND_REF_NM === "");
	            // @ts-ignore
	            tempRows =  sheet.getDataRows().filter(x => x.FIND_REF_NM !== "오류" && x.FIND_REF_NM !== undefined && x.FIND_REF_NM !== "");
		    }
            
            if(perfCorpYn != 'N') {
                for(var i=0; i<rows.length; i++) {
                    if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == ""){
                        UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                        return;
                    }
                }
            } else {
                for(var i=0; i<rows.length; i++) {
                    if(rows[i]["SUPP_CORP_NM"] == "" || rows[i]["SUPP_BIZ_NO"] == "" || rows[i]["PAY_AMT"] == "" ||
                        rows[i]["SUPP_CEO_NM"] == "" || rows[i]["SPC_RELATE_PERSON_YN"] == "" || rows[i]["SUPP_ACC_BANK_CD"] == "" ||
                        rows[i]["SUPP_ACC_NO"] == "" || rows[i]["SUPP_ACC_HOLDER"] == "" || rows[i]["SUPP_CORP_YN"] == "" || rows[i]["PARTNER_CORP_YN"] == ""
                    ){
                        UIUtils.alert('중소기업 지급 정보를 입력해주세요').then();
                        return;
                    }
                }
            }
        }
		
		
		
        let corpItems: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItem: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};

        for (var i = 0; i < rows.length; i++) {

            let suppBizNo = rows[i]["SUPP_BIZ_NO"].toString().replaceAll('-','');
            let suppAccNo = rows[i]["SUPP_ACC_NO"].toString().replaceAll('-','');

            // @ts-ignore
            corpItem = {
                SUPP_CORP_NM: rows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: suppBizNo,
                PAY_AMT: rows[i]["PAY_AMT"],
                SUPP_CEO_NM: rows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: rows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: rows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: suppAccNo,
                SUPP_ACC_HOLDER: rows[i]["SUPP_ACC_HOLDER"],
                VAT_YN: rows[i]["VAT_YN"],
                SUPP_CORP_YN: rows[i]["SUPP_CORP_YN"],
                PARTNER_CORP_YN: rows[i]["PARTNER_CORP_YN"],
                ERR_CD: rows[i]["ERR_CD"],
                ERR_MSG: rows[i]["ERR_MSG"],
            }
            corpItems.push(corpItem);
        }

        let corpItemsTemp: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; }[] = [];
        // @ts-ignore
        let corpItemTemp: { SUPP_CORP_NM:string, SUPP_BIZ_NO:string, PAY_AMT:number, SUPP_CEO_NM:string, SPC_RELATE_PERSON_YN:string, SUPP_ACC_BANK_CD:string, SUPP_ACC_NO:string, SUPP_ACC_HOLDER:string, FIND_REF_NM:string, VAT_YN:string, SUPP_CORP_YN:string, PARTNER_CORP_YN:string, ERR_CD:string, ERR_MSG:string; } = {};

        for (var i = 0; i < tempRows.length; i++) {

            let tempSuppBizNo = tempRows[i]["SUPP_BIZ_NO"].toString().replaceAll('-','');
            let tempSuppAccNo = tempRows[i]["SUPP_ACC_NO"].toString().replaceAll('-','');

            // @ts-ignore
            corpItemTemp = {
                SUPP_CORP_NM: tempRows[i]["SUPP_CORP_NM"],
                SUPP_BIZ_NO: tempSuppBizNo,
                PAY_AMT: tempRows[i]["PAY_AMT"],
                SUPP_CEO_NM: tempRows[i]["SUPP_CEO_NM"],
                SPC_RELATE_PERSON_YN: tempRows[i]["SPC_RELATE_PERSON_YN"],
                SUPP_ACC_BANK_CD: tempRows[i]["SUPP_ACC_BANK_CD"],
                SUPP_ACC_NO: tempSuppAccNo,
                SUPP_ACC_HOLDER: tempRows[i]["SUPP_ACC_HOLDER"],
                VAT_YN: tempRows[i]["VAT_YN"],
                SUPP_CORP_YN: tempRows[i]["SUPP_CORP_YN"],
                PARTNER_CORP_YN: tempRows[i]["PARTNER_CORP_YN"],
                ERR_CD: tempRows[i]["ERR_CD"],
                ERR_MSG: tempRows[i]["ERR_MSG"],
                FIND_REF_NM: tempRows[i]["FIND_REF_NM"],
            }
            corpItemsTemp.push(corpItemTemp);
        }


        let param = { LIST: corpItems };
        let tempParam = { LIST: corpItemsTemp };

        //파라미터 전송
        const response:any = await CommonUtil.execute({
            url:'usr_2117',
            data: param
        }).then((response:any) => {
           	const SheetData = response.REC;
           	let finalRows:any;
           	
           	if(tempRows.length == 0){
				 finalRows = SheetData;	   
	  	    }else{
				 finalRows = SheetData.concat(tempParam.LIST);				  
			}
            
			
            if(type == '2120'){
                // @ts-ignore
                sheet.loadSearchData(finalRows);
            } else {

                // @ts-ignore
                sheet_modal.loadSearchData(finalRows);
            }
        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });

    }


    // 지원기업(수행기업있는) 양식 다운로드
    const subjTemplateDownload = () => {
        console.log("subjTemplateDownload");
        let fileName = "";
        if(perfCorpYn != 'N'){
            fileName = "suppListTemplate2.xlsx"     // 지원기업 양식(축소버전)
        } else {
            fileName = "suppListTemplate1.xlsx"     // 지원기업 양식(풀양식)
        }
        CommonUtil.downloadTemplateFile(fileName, "지원기업내역(양식).xlsx");
    };

    // 지원기업 양식 업로드
    const subjTemplateUpload = () => {
        //@ts-ignore
        let rows = sheet.getDataRows();
        //@ts-ignore
        sheet.removeRows(rows);
        //@ts-ignore
        sheet.loadExcel({ mode: 'HeaderSkip' });
    }

    // 수행기업 양식 다운로드
    const subjTemplateDownload2 = () => {
        console.log("subjTemplateDownload2");
        CommonUtil.downloadTemplateFile("perfListTemplate.xlsx", "수행기업내역(양식).xlsx");
    };

    // 수행기업 양식 업로드
    const subjTemplateUpload2 = () => {
        //@ts-ignore
        let rows = sheet_modal.getDataRows();
        //@ts-ignore
        sheet_modal.removeRows(rows);
        //@ts-ignore
        sheet_modal.loadExcel({ mode: 'HeaderSkip' });
    }


	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={2}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 등록</h1>
                    {/*
					<div className="hz-root hz-right hz-gap10 mb30">
						<Button color="gray-o" size="md" onClick={() => clickCancel()}>취소</Button>
						<Button color="pri" size="md" onClick={() => SaveReq()}>저장</Button>
						<Button color="gray-o" size="md" href="/main/usr_2100/usr_2114">목록</Button>
					</div>
                    */}
					<section className="fund-section">
						<div className="hz-root hz-gap10 hz-sb mb15">
							<h3 className="section-title">지급 신청 정보 확인</h3>
							<p className="tx-msg"><span className="fc-pri">*</span>&nbsp;필수 입력</p>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">지급신청일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={payReqDate} placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">과제 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
                            <div className="inner">
                                <div className="fo-item fo-m-1-3">
                                    <div className="fo-key">
                                        <span>과제명</span>
                                        <button type="button" className="button-tooltip"
                                                data-tooltip-id="tooltip1">도움말
                                        </button>
                                        <Tooltip
                                            id="tooltip1"
                                            disableStyleInjection={true}
                                            place={"bottom-start"}
                                            className="tooltip-conts"
                                        >
                                            <div className="msg">과제 운영기간(최대 1년), 사업기간 변경 시 과제변경 신청 필수<br/>
                                                (★사업기간 내 사업 운영 및 비용 집행★) 모든 제출 증빙자료의 발행일자가 과제 기간 내에 포함될 수 있도록 설정
                                                바랍니다.<br/>
                                                ex)견적서, 세금계산서,이체확인증 등<br/>
                                                ※ 당해연도 지급 요청 마감은 매년 11월 30일 18:00까지이며 이후 당해연도 내 추가 지급신청 불가
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={tskNm} placeholder={''}
                                                 readOnly={true}/>
                                    </div>
                                </div>
                                <div className="fo-item fo-m-1-3">
                                    <div className="fo-key">
                                        <span>과제신청번호</span>
                                    </div>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={tskReqNo} placeholder={''}
                                                 readOnly={true}/>
                                    </div>
                                </div>

                                <div className="fo-item">
                                    <div className="fo-key">
                                        <span>과제기간</span>
                                        <button type="button" className="button-tooltip"
                                                data-tooltip-id="tooltip3">도움말
                                        </button>
                                        <Tooltip
                                            id="tooltip3"
                                            disableStyleInjection={true}
                                            place={"bottom-start"}
                                            className="tooltip-conts"
                                        >
                                            <div className="msg">
                                                <h6 className="tooltip-title">과제 운영기간(최대 1년), 사업기갑 변경 시 과제변경 신청 필수</h6>
                                                <span className="fc-pri">(사업기간 내 사업 운영 및 비용 집행)</span> <br/>
                                                모든 제출 증빙자료의 발행일자가 고제 기간 내에 포함될 수 있도록 설정 바랍니다.<br/>ex) 견적서, 세금계선서, 이체확인증
                                                등<br/>
                                                <p className="mt5">※ 해당연도 지급 요청 마감은 매년 11월 30일 18:00까지이며 이후 당해연도 내 추가
                                                    지급신청 불가.</p>
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <div className="fo-value">
                                        <div className="hz-root hz-left hz-gap5">
                                            <UIInput className={'w280 hz-fg tf tf-md'}
                                                     value={tskStDate + ' ~ ' + tskEnDate} placeholder={''}
                                                     readOnly={true}/>
                                            {/* <div className="hz-item tx-msg">(MM월DD일)</div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <div className="fo-key">
                                        <span>지급신청 가능금액</span>
                                    </div>
                                    <div className="fo-value">
                                        <div className="hz-root hz-gap5 w100p">
                                            <div className="tf-unit hz-item hz-fg">
                                                <UIInput className={'tf tf-md ta-right'}
                                                         value={StringUtil.formatNumber(Number(reqAmt)) || "0"}
                                                         placeholder={''} readOnly={true}/>
                                                <span className="u">원</span>
                                            </div>
                                            <div className="hz-item tx-msg"><span
                                                className="fc-pri">({StringUtil.isNotEmpty(reqAmt + "") ?
                                                StringUtil.numKorPattern(reqAmt) + " 원" : "원"})</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">사업분류</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={bizNm} placeholder={''}
                                                 readOnly={true}/>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <div className="fo-key">
                                        <span>기금사용용도</span>
                                        <button type="button" className="button-tooltip"
                                                data-tooltip-id="tooltip4">도움말
                                        </button>
                                        <Tooltip
                                            id="tooltip4"
                                            disableStyleInjection={true}
                                            place={"bottom-start"}
                                            className="tooltip-conts"
                                        >
                                            <div className="msg">[참고] 상생협력기금 사용용도 분류표’를 참조하여 해당하는 번호를 기입</div>
                                        </Tooltip>
                                    </div>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={funPurUseNm} placeholder={''}
                                                 readOnly={true}/>
                                    </div>
                                </div>

                                <div className="fo-item">
                                    <p className="fo-key">과제분야(대분류)</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={bizKindNm1} placeholder={''}
                                                 readOnly={true}/>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">과제분야(소분류)</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={bizKindNm2} placeholder={''}
                                                 readOnly={true}/>
                                    </div>
                                </div>
                                {perfCorpYn != 'N' &&
                                    <div className="fo-item fo-m-1-3">
                                        <div className="fo-key">
                                            <span>수행기관</span>
                                            <button type="button" className="button-tooltip"
                                                    data-tooltip-id="tooltip5">도움말
                                            </button>
                                            <Tooltip
                                                id="tooltip5"
                                                disableStyleInjection={true}
                                                place={"bottom-start"}
                                                className="tooltip-conts"
                                            >
                                                <div className="msg">
                                                    효율적인 사업수행을 위하여 출연기업이 선정한 대행기관(기업)을 의미하며,<br/>
                                                    협력재단이 수행기관에게 직접 지급하는 경우에만 사업자등록증의 상호명을 기입<br/>
                                                    (수행기관 변경 및 추가 시 사업변경 신청 필수)
                                                </div>
                                            </Tooltip>
                                        </div>
                                        <div className="fo-value">
                                            <UIInput className={'tf tf-md w100p'} value={corpListText} placeholder={''}
                                                     readOnly={true}/>
                                        </div>
                                    </div>
                                }
                            </div>
                        </form>
                    </section>
                    <section className="fund-section">
                        <h3 className="section-title mb15">지원금 지급 방식</h3>
                        <form className="fo fo-col2" name="" action="" method="">
                            <div className="inner">
                                <div className="fo-item">
                                    <div className="fo-key">
                                        <span>지원금 지급방식</span>
                                        <button type="button" className="button-tooltip"
                                                data-tooltip-id="tooltip6">도움말
                                        </button>
                                        <Tooltip
                                            id="tooltip6"
                                            disableStyleInjection={true}
                                            place={"bottom-start"}
                                            className="tooltip-conts"
                                        >
                                            <div className="msg">
                                                <h6 className="tooltip-title">하기 해당되는 상생협력기금 지급방식을 체크하고 관련 내용을 기입</h6>
                                                <ul className="list-group">
                                                    <li>(일괄정산) 출연기업이 협력재단에 제출한 지급신청서 및 정산서류를 확인하여 1회 지원금 지급하여 종료하는 과제
                                                    </li>
                                                    <li>(분할정산) 2회 이상 지급이 필요한 과제 또는 선지급이 필요한 경우</li>
                                                    <li>(선지급여부) 과제 내용에 따라 선지급 요청 가능, 최대 70%로 제한</li>
                                                </ul>
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <div className="fo-value">
                                        <div className="hz-root hz-gap15">
                                            <label htmlFor="rd-1-1" className="ip-rd-label">
                                                <input name="rd-1" id="rd-1-1" className="ip-rd" type="radio"
                                                       checked={forePayYn === 'N'} onChange={handleOptionChange}/>
                                                <span className="check"></span>
                                                <span className="txt">사후정산</span>
                                            </label>
                                            <label htmlFor="rd-1-2" className="ip-rd-label">
                                                <input name="rd-1" id="rd-1-2" className="ip-rd" type="radio"
                                                       checked={forePayYn === 'Y'} onChange={handleOptionChange}/>
                                                <span className="check"></span>
                                                <span className="txt">선지급</span>
                                            </label>
                                            {bizCd == '008' &&
                                                <div>
                                                    <span className="fc-pri">
                                                        민간자율기획사업으로 신청하시는 경우, <br/>선지급은 과제비용의 최대 70%까지 가능합니다.
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">총 지급신청금액</p>
                                    <div className="fo-value">
                                    <div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(totalAmt)) || "0"} placeholder={''} readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(totalAmt + "") ?
                                                                                                         StringUtil.numKorPattern(totalAmt) + " 원" : "원"})</span></div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title hz-item">지원금 지원 기업</h3>
							<div className="hz-root hz-gap8">
							    {perfCorpYn != 'N' ? (
                                    <>
                                        <Button color='gray-o' size="sm" onClick={() => setModal2122IsOpen(true)}>수행기업 목록 등록</Button>
                                    </>
                                    ) : (
                                        <> </>
                                    )}
								<Button color='gray-o' size="sm" onClick={() => setModal2120IsOpen(true)}>지원기업 목록 등록</Button>
							</div>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">
										<span>지원기업 수</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip7">도움말</button>
										<Tooltip 
											id="tooltip7"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수혜받는 중소기업 수를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 ">
											<UIInput className={'tf tf-md ta-right hz-item hz-fg'} value={StringUtil.formatNumber(Number(suppTotCnt)) || 0} placeholder={''} readOnly={true}/>
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span>중소기업 지원금액</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip8">도움말</button>
										<Tooltip 
											id="tooltip8"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">지원(중소)기업에 직접 지급되는 금액</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(suppTotAmt)) || "0"} placeholder={''} readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(suppTotAmt + "") ?
                                                                                                            StringUtil.numKorPattern(suppTotAmt) + " 원" : "원"})</span></div>
										</div>
									</div>
								</div>
								{perfCorpYn != 'N' ? (
                                <>
								<div className="fo-item">
									<div className="fo-key">
										<span>수행기관 수</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip9">도움말</button>
										<Tooltip 
											id="tooltip9"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수행기업 수를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIInput className={'tf tf-md ta-right hz-item hz-fg'} value={StringUtil.formatNumber(Number(perfTotCnt)) || 0} placeholder={''} readOnly={true}/>
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span>수행기관 지급금액</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip10">도움말</button>
										<Tooltip 
											id="tooltip10"  
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수행기관이 있는경우, 수행기관에 지급되는 금액</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(perfTotAmt)) || "0"} placeholder={''} readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(perfTotAmt + "") ?
                                                                                                        StringUtil.numKorPattern(perfTotAmt) + " 원" : "원"})</span></div>
										</div>
									</div>
								</div>
								</>
								) : (
                                    <> </>
                                )}

							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
                                        <UIInputMask
                                            mask={"999999-9999999"}
                                            className={'tf tf-md w100p'}
                                            value={corpRegNo}
                                            readOnly={true}
                                        />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
                                        <UIInputMask
                                            mask={"999-99-99999"}
                                            className={'tf tf-md w100p'}
                                            value={bizNo}
                                            readOnly={true}
                                        />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={personNm} valueChanged={(value) => {setPersonNm(value)}} placeholder={''}/>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">직급</p>
                                    <div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={''} valueChanged={(value) => setPosiNm(value)}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={''} valueChanged={(value) => setDeptNm(value)}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
                                        <UIInput className={'tf tf-md w100p'} value={emailAdres} valueChanged={(value) => {setEmailAdres(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={ofcTelNo} placeholder={''} valueChanged={(value) => setOfcTelNo(value)}/>
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md" onClick={() => clickCancel()}>취소</Button>
						<Button color="pri" size="md" onClick={() => SavePay()}>저장</Button>
						<Button color="gray-o" size="md" href="/main/usr_2100/usr_2114">목록</Button>
					</div>
				</main>
			</div>
			{/* modal - 지원기업 목록 등록 */}
			<ModalPopup
				open={modal2120IsOpen}
				title="지원기업 목록 등록"
				size="xlg"
				onClose={() => onClose('2120')}
				onAfterOpen={() => onAfterOpen('2120')}
			>
				<div className="modal-con">
					<div className="hz-root hz-right hz-gap5 mb15">
                        {perfCorpYn != 'Y' &&
						<Button color='pri' size="sm" onClick={() => checkInq('2120')}>예금주조회</Button>
                        }
						<Button color='pri-o' size="sm" onClick={() => addRow('2120')}>행추가</Button>
                        <Button color='gray-o' size="sm" onClick={() => delRow('2120')}>행삭제</Button>
                        <Button color='pri-o' size="sm" onClick={subjTemplateDownload}>지원기업목록 양식받기</Button>
                        <Button color='gray-o' size="sm" onClick={subjTemplateUpload}>지원기업목록 Upload</Button>
					</div>
					<div className="tb-total mb15">
						<div className="tb-total-items">지원 금액 합계(원)</div>
						<div className="tb-total-items">
							<div className="fund-form-items tf-unit">
								<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(suppTmpAmt)) || "0"} placeholder={''}  readOnly={true}/>
								<span className="u">원</span>
							</div>
							<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(suppTmpAmt + "") ?
                                                            StringUtil.numKorPattern(suppTmpAmt) + " 원" : "원"})</span></p>
						</div>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{suppTmpCnt}</em>건</p>
						</div>
                        {/*
						<div className="hz-root hz-gap5">
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" value={showRowCnt}  onChange={(handleSelect)}>
                                    <option value="20">20개씩보기</option>
                                    <option value="50">50개씩보기</option>
                                    <option value="100">100개씩보기</option>
                                    <option value="200">200개씩보기</option>
                                    <option value="500">500개씩보기</option>
                                    <option value="1000">1000개씩보기</option>
                                </select>
							</div>
						</div>
                        */}
					</div>
					<div className="ibsheet" id="modal_2120_List" style={{height:"423px"}}>[D] IBSHEET 영역</div>
					<div id="pageNavi" className="pg"></div>
					<p className="tx-msg mt10">※ [지원기업 목록]의 지원금액합계와 [수행금액 목록]의 지급금액합계가 일치하도록 작성하여 주시기 바랍니다.</p>
				</div> 
				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={() => onClose('2120')}>취소</Button>
					<Button color="pri" size="md" onClick={() => saveCorp('2120')}>저장</Button>
				</div>
			</ModalPopup>
			{/* modal - 수행기관 목록 등록 */}
			<ModalPopup
				open={modal2122IsOpen}
				title="수행기관 목록 등록"
				size="xlg"
				onClose={() => onClose('2122')}
				onAfterOpen={() => onAfterOpen('2122')}
			>
			    <section className="fund-section">
                    <div className="modal-con">
                        <div className="hz-root hz-right hz-gap5 mb15">
                            <Button color='pri' size="sm" onClick={() => checkInq('2122')}>예금주조회</Button>
                            <Button color='pri-o' size="sm" onClick={() => addRow('2122')}>행추가</Button>
                            <Button color='gray-o' size="sm" onClick={() => delRow('2122')}>행삭제</Button>
                            <Button color='pri-o' size="sm"  onClick={subjTemplateDownload2}>수행기업목록 양식받기</Button>
                            <Button color='gray-o' size="sm" onClick={subjTemplateUpload2}>수행기업목록 Upload</Button>
                        </div>
                        <div className="tb-total mb15">
                            <div className="tb-total-items">지원 금액 합계(원)</div>
                            <div className="tb-total-items">
                                <div className="fund-form-items tf-unit">
                                    <UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(perfTmpAmt)) || "0"} placeholder={''}  readOnly={true}/>
                                    <span className="u">원</span>
                                </div>
                                <p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(perfTmpAmt + "") ?
                                                                StringUtil.numKorPattern(perfTmpAmt) + " 원" : "원"})</span></p>
                            </div>
                        </div>
                        <div className="tb-top">
                            <div>
                                <p className="tx fc-black">총 <em className="fw500">{perfTmpCnt}</em>건</p>
                            </div>
                            {/*
                            <div className="hz-root hz-gap5">
                                <div className="sl sl-sm w120">
                                    <select name="showRowCnt" id="showRowCnt" value={showRowCnt}  onChange={(handleSelect)}>
                                        <option value="20">20개씩보기</option>
                                        <option value="50">50개씩보기</option>
                                        <option value="100">100개씩보기</option>
                                        <option value="200">200개씩보기</option>
                                        <option value="500">500개씩보기</option>
                                        <option value="1000">1000개씩보기</option>
                                    </select>
                                </div>
                            </div>
                            */}
                        </div>
                        <div className="ibsheet" id="modal_2122_List" style={{height:"423px"}}>[D] IBSHEET 영역</div>
                        <div id="pageNavi" className="pg"></div>
                        <p className="tx-msg mt10">※ [지원기업 목록]의 지원금액합계와 [수행금액 목록]의 지급금액합계가 일치하도록 작성하여 주시기 바랍니다.</p>
                    </div>
                </section>

				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={() => onClose('2122')}>취소</Button>
                    <Button color="pri" size="md" onClick={() => saveCorp('2122')}>저장</Button>
				</div>

			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;